/* eslint-disable no-restricted-imports */
import { createPlugin } from '../../../../Fct/createPlugin';
import { FctAddress, FctValue } from '../../../../Fct/generics';
import { getSupportedContracts } from '../../../../Fct/plugins/allowanceRequiredProtocols';
import { WETH_ADDRESSES } from '../helpers/contracts';
export var WrapETH = createPlugin({
    protocol: 'UTILITY',
    type: 'ACTION',
    description: 'Wrap ETH into WETH',
    method: 'deposit',
    name: 'wrapETH',
    supportedContracts: [
        { address: '0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2', chainId: 1 },
        { address: '0x82aF49447D8a07e3bd95BD0d56f35241523fBab1', chainId: 42161 },
        { address: '0x7b79995e5f793A07Bc00c21412e50Ecae098E7f9', chainId: 11155111 },
    ],
    getParams: function (_a) {
        var chainId = _a.chainId;
        return ({
            input: {
                to: new FctAddress({
                    destination: 'wrapped_ether',
                    options: getSupportedContracts({ chainId: chainId, contracts: WETH_ADDRESSES }),
                }),
                value: new FctValue({
                    destination: 'wei_amount',
                }),
                methodParams: {},
            },
            output: {},
        });
    },
});
